(function(){

    var FLIPPING_CARDS = document.querySelectorAll('.flipping-card');

    if(!FLIPPING_CARDS.length) return false;

    document.addEventListener('click', (evt) => {
        if(evt.target.classList.contains('flipping-card')){
            evt.target.classList.toggle('flipped');
            return false;
        } else {
            var card = evt.target.closest('.flipping-card');
            if(card) {
                card.classList.toggle('flipped');
                return false;
            }
        }

    });

    
}());